/**
 * 搜索的字段名，
 * 断面宽，尺寸，花纹,
 * 规则
 */
export enum ProductFilterKeysEnums {
  SELECT_WIDTH = "sectionWidth",
  HUB_DIAMETER = "hubDiameter",
  PATTERN = "pattern"
}
/**
 * 搜索排序的字段名，断面宽，尺寸
 */
export enum ProductSortKeysEnums {
  SELECTION_WIDTH = "_sectionWidthSort",
  HUB_DIAMETER = "_hubDiameterSort"
}
